"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FitLevel = void 0;
var FitLevel;
(function (FitLevel) {
    FitLevel["POOR_MATCH"] = "Poor match";
    FitLevel["FAIR_MATCH"] = "Fair match";
    FitLevel["GOOD_MATCH"] = "Good match";
    FitLevel["VERY_GOOD_MATCH"] = "Very good match";
    FitLevel["EXCELLENT_MATCH"] = "Excellent match";
})(FitLevel || (exports.FitLevel = FitLevel = {}));
